import React, { useState } from 'react';
import classnames from 'classnames/bind';
import styles from './ShowMore.module.scss';
import { Typography } from 'gd-design-library';
import { Button } from '../Button';

const CN = 'show-more';
const cx = classnames.bind(styles);

const showMoreButtonClassName = `${CN}__button`;

interface ShowMoreProps {
  children: string;
  numOfCharsToShow?: number
}

const DEFAULT_NUM_OF_CHARS_TO_SHOW = 256;

export const ShowMore: React.FC<ShowMoreProps> = ({
  children: text,
  numOfCharsToShow = DEFAULT_NUM_OF_CHARS_TO_SHOW
}) => {
  const [ isShowMore, setIsShowMore ] = useState(false);

  const toggleShowMore = (): void => {
    setIsShowMore(!isShowMore);
  };

  return (
    <div className={ cx(CN) }>
      <Typography>
        {isShowMore || text.length <= numOfCharsToShow
          ? text
          : `${text.substring(0, numOfCharsToShow)}...`}
      </Typography>

      {text.length > numOfCharsToShow && (
        <Button
          variant='inherit'
          onClick={ toggleShowMore }
          className={ cx(showMoreButtonClassName) }
        >
          {isShowMore ? 'Show less' : 'Show more'}
        </Button>
      )}
    </div>
  );
};
